<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-3"><a id="Contents-A">Contents</a></p><a id="Contents-A">
</a></div><a id="Contents-A">
</a><div><a id="Contents-A">
<p class="ct"></p>
</a><p class="Contents-Entry"><a id="Contents-A"></a><a href="#/Capital_Crimes#toc_marker-1">Capital Crimes</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes1#toc_marker-2">Copyright</a></p>
<p class="Contents-Entry"><a href="#/#toc_marker-3">Contents</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes3#toc_marker-4">Introduction</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes4#toc_marker-5">The Case of Lady Sannox</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes5#toc_marker-6">A Mystery of the Underground</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes6#toc_marker-7">The Finchley Puzzle</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes7#toc_marker-8">The Magic Casket</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes8#toc_marker-9">The Holloway Flat Tragedy</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes9#toc_marker-10">The Magician of Cannon Street</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes10#toc_marker-11">The Stealer of Marble</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes11#toc_marker-12">The Tea Leaf</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes12#toc_marker-13">The Hands of Mr Ottermole</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes13#toc_marker-14">The Little House</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes14#toc_marker-15">The Silver Mask</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes15#toc_marker-16">Wind in the East</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes16#toc_marker-17">The Avenging Chance</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes17#toc_marker-18">They Don’t Wear Labels</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes18#toc_marker-19">The Unseen Door</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes19#toc_marker-20">Cheese</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes20#toc_marker-21">You Can’t Hang Twice</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes21#toc_marker-22">More from this Author</a></p>
<p class="Contents-Entry"><a href="#/Capital_Crimes22#toc_marker-23">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Capital_Crimes-2.vue?52d70242